import { chakraSelectDarkMode, defaultChakraSelectStyle } from '@/constants';
import { InfoIcon } from '@chakra-ui/icons';
import {
    Badge,
    Box,
    FormControl,
    FormErrorMessage,
    FormHelperText,
    FormLabel,
    Tooltip,
} from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { isEqual } from 'lodash';
import { useSelector } from 'react-redux';
import { useServices } from '../ServicesContext';
import style from './styles';
import useServicesAttributesValidation from './useServicesAttributesValidation';

export default function BoolAttribute({
    attribute,
    index,
    serviceIndex,
    requiredScope,
    isBusy,
}) {
    const options = [
        {
            value: '0',
            label: 'False',
        },
        {
            value: '1',
            label: 'True',
        },
    ];
    const validation = JSON.parse(attribute.definedAttributeValidationType);
    const { removeAttributeError, handleAttributeChange } =
        useServicesAttributesValidation();
    const { attributesErrors, services } = useServices();
    const { darkMode } = useSelector((state) => state.settings);
    const chakraSelectDark = chakraSelectDarkMode(darkMode);

    const error = attributesErrors.find(
        (obj) => obj.id === index && obj.serviceIndex === serviceIndex,
    );

    const updateAttribute = services[serviceIndex].attributes[index];

    return (
        <Box sx={style.fieldContainer}>
            <FormControl isRequired={validation.Required} isInvalid={error}>
                <FormLabel sx={style.label}>
                    {attribute.name}{' '}
                    {attribute.toolTip && (
                        <Tooltip
                            label={attribute.toolTip}
                            hasArrow
                            placement="top-end">
                            <InfoIcon />
                        </Tooltip>
                    )}
                </FormLabel>

                <Box display="flex" flexDirection={'row'}>
                    <Box w={'100%'} mr={1}>
                        <Select
                            value={options?.find(
                                (item) => item.value === updateAttribute?.value,
                            )}
                            options={options}
                            onChange={(e) => {
                                removeAttributeError(index, serviceIndex);
                                handleAttributeChange(
                                    e.value,
                                    index,
                                    serviceIndex,
                                );
                            }}
                            placeholder="Please select an option"
                            getOptionLabel={(i) => i.label}
                            chakraStyles={{
                                ...defaultChakraSelectStyle,
                                ...chakraSelectDark,
                            }}
                            isDisabled={
                                requiredScope < attribute.updateScope || isBusy
                            }
                        />
                    </Box>
                    {!isEqual(updateAttribute?.value, attribute.value) && (
                        <Box alignContent={'center'} ml={1}>
                            <Badge colorScheme="orange">Unsaved</Badge>
                        </Box>
                    )}
                </Box>

                {error ? (
                    <FormErrorMessage>{error.message}</FormErrorMessage>
                ) : attribute?.description ? (
                    <FormHelperText>{attribute?.description}</FormHelperText>
                ) : null}
            </FormControl>
        </Box>
    );
}
